import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { Paper, CircularProgress } from '@mui/material';
import { useInfoStore } from '../store/userInfo';  // useInfoStore의 경로는 프로젝트 구조에 맞게 설정

const ProtectedRoute = () => {
  const { isLogin } = useInfoStore();

  // 기본값 설정 및 데이터 유효성 체크
  const isAuthenticated = Boolean(isLogin);  // isLogin이 null, undefined일 경우 false로 처리

  // isLogin의 값이 아직 결정되지 않았을 때(로딩 상태) 처리
  if (typeof isLogin === 'undefined') {
    return (
      <Paper sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
      }}>
        <CircularProgress />  {/* 로딩 인디케이터 표시 */}
      </Paper>
    );
  }

  // 로그인 상태에 따른 라우팅 처리
  if (!isAuthenticated) {
    return <Navigate to="/userlogin" />;
  }

  return (
    <Paper sx={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      backgroundColor: '#fff',
      overflow: 'hidden',
    }}>
      <Outlet />
    </Paper>
  );
};

export default ProtectedRoute;
